const COMMIT_DATA_STATUS = {
  ERROR: 'error',
  SUCCESS: 'success',
  IDLE: 'idle',
  FETCHING: 'fetching'
};

export default COMMIT_DATA_STATUS;
